import { ChevronDown } from "lucide-react";
import { useWorkspaceCompany } from "@/hooks/use-workspace-company";
import { useMicroappContext } from "@/framework/microapp-context";

export function CompanyPicker() {
  const { embedded } = useMicroappContext();
  const {
    companyId,
    companies,
    isLoadingCompanies,
    isCompaniesError,
    setCompanyId,
  } = useWorkspaceCompany();

  if (embedded) {
    return null;
  }

  if (isLoadingCompanies && companies.length === 0) {
    return <span className="tl-fy-picker-hint">Loading companies…</span>;
  }

  return (
    <div className="tl-fy-picker">
      <div className="tl-select-shell">
        <select
          className="tl-select"
          value={companyId}
          onChange={(event) => setCompanyId(Number(event.target.value))}
          disabled={isLoadingCompanies || isCompaniesError || companies.length === 0}
          aria-label="Company"
          data-testid="select-company"
        >
          {companies.map((company) => (
            <option key={company.companyId} value={company.companyId}>
              {company.name}
            </option>
          ))}
        </select>
        <ChevronDown size={14} aria-hidden="true" />
      </div>
      {isCompaniesError && (
        <span className="tl-fy-picker-error">Company list unavailable</span>
      )}
    </div>
  );
}
